import React, { useState } from 'react';

function WebDesignTailoredSolutions() {
  const [mouseOffset, setMouseOffset] = useState(0);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const centerX = rect.width / 2;
    // Calculate normalized offset from -1 to 1
    const normalized = (x - centerX) / centerX;
    setMouseOffset(normalized);
  };

  const handleMouseLeave = () => {
    setMouseOffset(0);
  };

  const handleBoxClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  // Subtle interactive parallax translation
  const leftParallax = mouseOffset ? `translateX(${mouseOffset * -16}px)` : undefined;
  const rightParallax = mouseOffset ? `translateX(${mouseOffset * 16}px)` : undefined;

  return (
    <section className="webdesign-tailored-section">
      <div className="container">
        {/* Section Header */}
        <div className="webdesign-tailored-header">
          <div className="webdesign-tailored-badge-row">
            <span className="webdesign-tailored-badge">Strategic Engineering</span>
            <div className="webdesign-tailored-badge-line"></div>
          </div>

          <h2 className="webdesign-tailored-title">
            Tailored Web Design Solutions, <span className="text-red">Limitless Growth</span>
          </h2>

          <p className="webdesign-tailored-subtitle">
            From bespoke full-stack web applications to conversion-focused digital commerce storefronts, we craft experiences that scale your business.
          </p>
        </div>

        {/* 2 Interactive Showcase Boxes with Left/Right Movement on Hover */}
        <div 
          className="webdesign-tailored-grid"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          {/* Left Box: Web Development Mockup */}
          <div 
            className="tailored-showcase-box box-left"
            onClick={handleBoxClick}
            style={{ transform: leftParallax }}
          >
            <div className="tailored-mockup-wrapper">
              <img 
                src="/assets/images/web-design/web-img4.png" 
                alt="Web Development Showcase Mockup" 
                className="tailored-mockup-img"
              />
            </div>
          </div>

          {/* Right Box: E-Commerce Storefront Mockup */}
          <div 
            className="tailored-showcase-box box-right"
            onClick={handleBoxClick}
            style={{ transform: rightParallax }}
          >
            <div className="tailored-mockup-wrapper">
              <img 
                src="/assets/images/web-design/web-img5.webp" 
                alt="E-Commerce Storefront Showcase Mockup" 
                className="tailored-mockup-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDesignTailoredSolutions;
